import { Box, Grid } from '@material-ui/core';
import { useCallback, useMemo } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { selectRecintosAduaneiros } from '../../features/recinto-aduaneiro/recintoAduaneiroSlice';
import { isStrictEquals } from '../../utils/general/general-utils';
import QCXFinalBondManager from '../final-gerenciador-relacionamento/QCXFinalBondManager';
import QCXSelectRecintoAduaneiroAutocomplete from './QCXSelectRecintoAduaneiroAutocomplete';

export default function QCXRecintoAduaneiroBondManager({
  isConsult = false,
  listRootName = 'listaRecintoAduaneiroEnvioEmail',
}) {
  const form = useForm();

  const recintos = useSelector(selectRecintosAduaneiros);

  const handleAdd = useCallback((currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
    const novoVinculo = {
      id: uuid(),
      recintoAduaneiro: currentVinculo.recintoAduaneiro,
    };

    const updatedVinculos = [...currentVinculos, novoVinculo];

    form.change('ignorableFields.recintoAduaneiroBond.recintoAduaneiro.id', '');

    handleSuccessAddVinculo(updatedVinculos);
  }, []);

  const handleUpdate = useCallback((currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
    const updatedVinculos =
      currentVinculos?.map((existingVinculo) =>
        isStrictEquals(existingVinculo?.recintoAduaneiro?.id, currentVinculo?.recintoAduaneiro?.id)
          ? currentVinculo
          : existingVinculo
      ) || currentVinculos;

    handleSuccessUpdateVinculo(updatedVinculos);
  }, []);

  const handleAlreadyExists = useCallback(
    (currentVinculo, currentVinculosList) =>
      currentVinculosList.some((vinculo) =>
        isStrictEquals(vinculo?.recintoAduaneiro?.id, currentVinculo?.recintoAduaneiro?.id)
      ),
    []
  );

  const mapRecintoById = (id) => recintos.find((urf) => urf.id === id);

  const listProps = {
    name: listRootName,
    columns: [
      {
        field: 'code',
        headerName: 'Código',
        flex: 200,
        valueGetter: ({ row }) => mapRecintoById(row?.recintoAduaneiro?.id)?.code ?? '-',
      },
      {
        field: 'nome',
        headerName: 'Nome',
        flex: 200,
        valueGetter: ({ row }) => mapRecintoById(row?.recintoAduaneiro?.id)?.description ?? '-',
      },
    ],
  };

  const formProps = useMemo(
    () => ({
      rootName: 'ignorableFields.recintoAduaneiroBond',
      fields: [
        {
          name: 'recintoAduaneiro',
          label: 'Recinto Aduaneiro',
        },
      ],
    }),
    []
  );

  return (
    <Box style={{ pointerEvents: isConsult ? 'none' : '' }}>
      <QCXFinalBondManager
        isParentConsult={isConsult}
        listProps={listProps}
        formProps={formProps}
        controlButtonsGridProps={{
          add: {
            xs: 12,
            sm: 2,
            md: 2,
          },
          update: {
            xs: 6,
            sm: 6,
            md: 1,
          },
          clear: {
            xs: 6,
            sm: 6,
            md: 1,
          },
        }}
        handleAdd={handleAdd}
        handleUpdate={handleUpdate}
        handleAlreadyExists={handleAlreadyExists}
      >
        <>
          <Grid item sm={6}>
            <QCXSelectRecintoAduaneiroAutocomplete
              id="autocomplete-select-recinto-aduaneiro-field"
              key="autocomplete-select-recinto-aduaneiro-field"
              name="ignorableFields.recintoAduaneiroBond.recintoAduaneiro.id"
              label="Recinto Aduaneiro"
              disabled={isConsult}
              autoLoad
            />
          </Grid>
        </>
      </QCXFinalBondManager>
    </Box>
  );
}
